/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import * as microsoftTeams from '@microsoft/teams-js';

/**
 * Checks if in microsoft teams environment.
 * Based on: https://github.com/wictorwilen/msteams-react-base-component/blob/master/src/useTeams.ts
 * @returns {boolean} True if in microsoft teams; otherwise false.
 */
export const useInMicrosoftTeams = () => {
  const microsoftTeamsLib = microsoftTeams || window['microsoftTeams'];

  if (!microsoftTeamsLib) {
    return false;
  }

  return (
    (window.parent === window.self && window.nativeInterface)
    || window.navigator.userAgent.includes('Teams/')
    || window.name === 'embedded-page-container'
    || window.name === 'extension-tab-frame'
  );
};
